"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = __importDefault(require("../../../constants/constants"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const AsyncStorage_1 = __importDefault(require("../../../utils/AsyncStorage"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const ConfirmDeleteAccountScreen = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [reason, setReason] = (0, react_1.useState)('');
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        (async () => {
            const _reason = await AsyncStorage_1.default.get(constants_1.default.REASON_DELETE);
            if (!!_reason) {
                setReason(_reason);
            }
        })();
        return () => {
            AsyncStorage_1.default.remove(constants_1.default.REASON_DELETE);
        };
    }, []);
    const onConfirm = async () => {
        setLoading(true);
        User_1.default.withdrawalAcc(reason)
            .then((_res) => {
            dispatch(slice_1.default.actions.showToast("アカウント削除が完了しました"));
            (0, rootNavigation_1.navigate)(Routes_1.default.CONFIRM_DELETE_SUCCESS_SCREEN);
            AsyncStorage_1.default.remove(constants_1.default.REASON_DELETE);
        })
            .catch((err) => {
            console.log('err', err);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
        } },
        react_1.default.createElement(react_native_1.View, { style: { zIndex: 1 } },
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "アカウント削除", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: "#007AFF",
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.MY_PROFILE);
                } })),
        react_1.default.createElement(react_native_1.ScrollView, { style: {
                flex: 1,
                backgroundColor: "#F7F7F7",
            }, contentContainerStyle: {
                paddingBottom: inset.bottom + (0, scale_1.scale)(20)
            }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            color: "#292A33",
                            fontWeight: "300",
                            paddingLeft: (0, scale_1.scale)(8),
                        } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u78BA\u8A8D")),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: "#292A33",
                        paddingTop: (0, scale_1.scale)(12),
                    } }, "\u307E\u3060\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u304C\u5B8C\u4E86\u3057\u3066\u3044\u307E\u305B\u3093\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: "#292A33",
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u7406\u7531\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: "#545454",
                        paddingTop: (0, scale_1.scale)(24),
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u7406\u7531"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: "#292A33",
                        paddingTop: (0, scale_1.scale)(8),
                    } }, reason),
                react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664", onPress: onConfirm }))),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = ConfirmDeleteAccountScreen;
